/**
 * What the fleet has just been told to do.
 *
 * Scoped server-side to the aircraft the caller may already see, so this is
 * not the admin audit table in a different colour — it is situational
 * awareness for whoever is watching the map.
 */

import { api, type ApiResult } from '@/api/client';

export interface ActivityEntry {
  entryId: string;
  /** Seconds since the epoch. */
  timestamp: number;
  droneId: string;
  username: string | null;
  detail: string;
  outcome: string;
}

export function listActivity(limit = 50): Promise<ApiResult<{ entries: ActivityEntry[] }>> {
  return api.get<{ entries: ActivityEntry[] }>(`/activity?limit=${limit}`, { logged: false });
}
